// src/pages/KrumsPage.js
import React, { useState } from 'react';
import CrisolKrums from '../components/krums/CrisolKrums';
import ReclamoDiario from '../components/krums/ReclamoDiario';
import TiendaPaquetes from '../components/krums/TiendaPaquetes';

function KrumsPage() {
  const [recargarCrisol, setRecargarCrisol] = useState(0);

  const handleKrumsReclamados = (nuevosKrums) => {
	   console.log('🎉 Krums actualizados:', nuevosKrums);
  // El Crisol se actualizará con la key
    setRecargarCrisol(prev => prev + 1); // Cambia la key y fuerza recarga
  };

  return (
    <div className="krums-page">
      <h1>🌟 Forja de Krums</h1>
      <div className="krums-page-content">
        <CrisolKrums key={recargarCrisol} /> {/* key cambia y fuerza recarga */}
        <ReclamoDiario onReclamar={handleKrumsReclamados} />
      </div>
      <TiendaPaquetes />
    </div>
  );
}

export default KrumsPage;